import { Application } from '@bybeam/platform-types';
import Button from '@platform-ui-common/components/Button/index.js';
import ErrorDisplay from '@platform-ui-common/components/ErrorDisplay/index.js';
import Typography from '@platform-ui-common/components/Typography/index.js';
import Color, { BackgroundColors } from '@platform-ui-common/utilities/Color.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import cx from 'classnames';
import React from 'react';
import { useHistory } from 'react-router';

interface ReviewSectionProps {
  title: string;
  children: React.ReactNode;
  redirectRoute: string;
  application: Application;
  isComplete?: boolean;
}

export default function ReviewSectionContainer({
  title,
  children,
  redirectRoute,
  application,
  isComplete = false,
}: ReviewSectionProps): JSX.Element {
  const history = useHistory();
  const redirectEdit = (): void =>
    history.push(makeRoute(`${redirectRoute}?review=true`, { applicationId: application.id }));
  return (
    <div className="flex flex-col justify-between gap-2">
      <div
        className={cx(
          `${BackgroundColors[Color.LightBackground]} py-6 px-6 lg:px-8 rounded grow`,
          !isComplete && 'border border-error',
        )}
      >
        <div className="flex gap-6 justify-between mb-3">
          <Typography variant="h2">{title}</Typography>
          <Button
            icon="edit"
            type="button"
            variant="text"
            textColor={Color.Primary}
            onClick={redirectEdit}
            className="text-sm leading-5 font-bold uppercase"
          >
            Edit
          </Button>
        </div>
        <div className="flex flex-col gap-4">{children}</div>
      </div>
      <ErrorDisplay message="Section incomplete" visible={!isComplete} />
    </div>
  );
}
